import _ from 'lodash';
import {
  CONSULTA_ADJUNTAR_COMPROBANTES_START,
  CONSULTA_ADJUNTAR_COMPROBANTES_CANCEL,
  CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS,
  CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SHOW_MODAL,
  CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_HIDE_MODAL,
  CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SPINNER_MODAL,
  PRESTADOR_ES_DIRECTO,
  CONSULTA_ADJUNTAR_COMPROBANTES_ERROR_SHOW_MODAL,
} from '../constants/index';

const initialState = {
  attachReceipts: null,
  attachReceiptsSuccess: [],
  showSuccessModal: { show: false, numero: null, spinnerShow: false },
  isDirect: null,
  showErrorModal: false,
};

export default function consultaDeLiquidacion(state = initialState, action) {
  const newState = _.cloneDeep(state);
  switch (action.type) {
    case CONSULTA_ADJUNTAR_COMPROBANTES_START:
      newState.attachReceipts = action.data;
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_CANCEL:
      newState.attachReceipts = null;
      newState.showSuccessModal = { show: false, numero: null, spinnerShow: false };
      newState.showErrorModal = false;
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS:
      newState.attachReceiptsSuccess.push(action.data);
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_ERROR_SHOW_MODAL:
      newState.showErrorModal = true;
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SHOW_MODAL:
      newState.showSuccessModal = { show: true, numero: action.data, spinnerShow: false };
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_HIDE_MODAL:
      newState.showSuccessModal = { show: false };
      return newState;
    case PRESTADOR_ES_DIRECTO:
      newState.isDirect = action.isDirect;
      return newState;
    case CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SPINNER_MODAL:
      newState.showSuccessModal = { show: false, numero: null, spinnerShow: action.data };
      return newState;
    default:
      return newState;
  }
}
